import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'

import BoxButton from '../Layout/BoxButton'
import ModalCreateDocumento from '../../components/ContratoAnual/ModalCreateDocumento'
import ModalSummaryDocumento from '../../components/ContratoAnual/ModalSummaryDocumento'

import ModalConfirmarAccion from '../../components/Shared/ModalConfirmarAccion'

import { isAllowedToViewComponent } from '../../utils/helpers'




import {
    displayModalCreateDocumento,
} from '../../actions/contratoanual'


import { showHideModalSummary } from '../../actions/documentos'

class Documentos extends Component {

    buttonOption = (documento, index) => {
        if (documento.getIn(['aprobacion','estado']) === 2) {
            return <BoxButton size={ 12 } name="binoculars" onClick={ () => this.props.showHideModalSummary(true, documento.get('id'), `solicitudes/contratos-anuales/${this.props.id}`, 'ACTUALIZAR_SOLICITUD_CONTRATOANUAL') } />
        } else {
            return <BoxButton size={ 12 } name="pencil" onClick={ () => this.props.displayModalCreateDocumento(true, 'Documento', index) } disabled={ !isAllowedToViewComponent('responsable_compras', this.props.contratoanual) || documento.get('estado') === 0 || documento.get('estado') === 2}/>
        }
    } 


	render() {

        const { id, contratoanual, enums } = this.props
        if (!id) return null               

		return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '23px' }}></th>
                                    <th style={{ width: '5%' }}>No.</th>
                                    <th style={{ width: '15%' }}>Proveedor</th>
                                    <th style={{ width: '10%' }}>Tipo documento</th>
                                    <th style={{ width: '10%' }}>Estado</th>
                                    <th style={{ width: '15%' }}>Inicio del contrato</th>
                                    <th style={{ width: '15%' }}>Terminación del contrato</th>
                                    <th>Tipo de servicio a desarrollar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    contratoanual.get('documentos').map((a, b) => {                                        
                                        return (
                                            <tr key={ `tr4[${a.get('id')}]` }>
                                                <td style={{ padding: '0' }}>{ this.buttonOption(a, b) }</td>
                                                <td>{ a.get('consecutivo') ? enums.documentos.tipos[a.get('tipo')].PREFIJO + a.get('consecutivo') : '' }</td>
                                                <td>{ a.getIn(['proveedore', 'nombre']) }</td>
                                                <td>{ enums.documentos.tipos[a.get('tipo')] ? enums.documentos.tipos[a.get('tipo')].NOMBRE : null }</td>
                                                <td>{ enums.documentos.estados[a.get('estado')] }</td>
                                                <td style={{ textAlign: 'right' }}>{ a.get('fecha_inicio') ? moment(a.get('fecha_inicio')).format('YYYY-MM-DD') : null }</td>
                                                <td style={{ textAlign: 'right' }}>{ a.get('fecha_entrega') ? moment(a.get('fecha_entrega')).format('YYYY-MM-DD') : null }</td>
                                                <td>{contratoanual.get('proyecto_evento')}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <ModalCreateDocumento />
                <ModalSummaryDocumento />
                <ModalConfirmarAccion />
            </div>
		)
	}
}




function mapStateToProps(state) {
    return {
        id: state.contratoanual.get('id'),
        contratoanual: state.contratoanual.get('solicitud'),
        enums: state.common.get('enums').toJS(),
    }
}



function mapDispatchToProps(dispatch) {
    return {
        displayModalCreateDocumento: (show, title, mode, indexDocumento) => dispatch(displayModalCreateDocumento(show, title, mode, indexDocumento)),
        showHideModalSummary: (show, id, url, type) => dispatch(showHideModalSummary(show, id, url, type)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documentos)


// WEBPACK FOOTER //
// ./src/components/ContratoAnual/Documentos.jsx